import script from "./CompanyModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyModal.vue?vue&type=script&setup=true&lang=js"

import "./CompanyModal.vue?vue&type=style&index=0&id=1e6125ca&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e6125ca"]])

export default __exports__